// extracted by mini-css-extract-plugin
export default {"badge":"ProvisionSSODefaultBadge-module__badge--e047p"};